import ajax from './ajax';

/* eslint-disable import/prefer-default-export */
export function requestBrandsList() {
  return ajax('/resources/list-brand/');
}
